import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { Link } from 'react-router-dom';

const NotFound = () => {
  usePageMeta({
    title: 'Agencive – Sivua ei löytynyt (404)',
    description: 'Etsimääsi sivua ei löytynyt. Palaa etusivulle tai ota yhteyttä.',
    path: '/404',
  });

  React.useEffect(() => {
    // Signal 404 to crawlers via a robots meta noindex tag on this page
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex, follow');
    document.head.appendChild(meta);
    return () => { if (meta.parentNode) meta.parentNode.removeChild(meta); };
  }, []);

  return (
    <main className="bg-bg min-h-screen flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-lg w-full text-center py-24">
        <p className="eyebrow text-ink-muted">404</p>
        <h1 className="mt-3 text-4xl md:text-5xl font-semibold text-ink tracking-tight">
          Sivua ei löytynyt
        </h1>
        <p className="mt-4 text-body text-ink-muted">
          Etsimääsi sivua ei enää ole tai osoite on kirjoitettu väärin. Palaa etusivulle tai
          ota yhteyttä, niin autamme eteenpäin.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center h-11 px-5 rounded-full bg-ink text-white text-[14.5px] font-medium hover:bg-dark transition-colors"
            data-testid="notfound-home-btn"
          >
            Etusivulle
          </Link>
          <Link
            to="/yhteys#contact-form"
            className="inline-flex items-center h-11 px-5 rounded-full border border-line text-[14.5px] text-ink-muted hover:text-ink hover:border-ink/40 transition-colors"
            data-testid="notfound-contact-btn"
          >
            Ota yhteyttä
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
